import { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router'
import { logout } from '../../actions/login'

const Timer = ({
  timeLeft = new Date(),
  lang
}) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const calculateTimeLeft = () => {
    const difference = timeLeft.getTime() - new Date().getTime()
    let countTime = {}

    if (difference > 0) {
      countTime = {
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      }
    } else if (!Number.isNaN(difference)) {
      dispatch(logout(lang, navigate))
    }
    return countTime
  }

  const [timerLeft, setTimerLeft] = useState(calculateTimeLeft())

  useEffect(() => {
    setTimeout(() => {
      setTimerLeft(calculateTimeLeft())
    }, 1000)
  })

  const { minutes, seconds } = timerLeft
  if (minutes || seconds) {
    return (
      <div className="text-primary timer-badge">
        {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
      </div>
    )
  }
  return null
}

Timer.propTypes = {
  timeLeft: PropTypes.instanceOf(Date),
  lang: PropTypes.string.isRequired
}

const mapStateToProps = (state) => {
  const { timeLeft } = state.login
  const { lang } = state.lang
  return {
    timeLeft,
    lang
  }
}

export default connect(mapStateToProps, null)(Timer)
